import { CompanyPortalSettings } from '../modules/scheduling/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import { PageHeader } from './page-title.js';

/// Configurações › Portal de clientes (ADR 0067, decisão 12): o que aparece da empresa na vitrine
/// pública. Mesma permissão do sinal, mas outro assunto: o sinal é cobrança, isto é publicação.
export function CompanyCustomerPortalSettingsScreen() {
  const { can, company } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('scheduling.settings.manage')}>
      <section>
        <PageHeader
          trail="Configurações / Portal de clientes"
          title="Portal de clientes"
          description="O que aparece da empresa na vitrine pública do portal. As regras do adiantamento continuam em Sinal do agendamento."
        />
        <CompanyPortalSettings
          companyKey={company.key}
          units={(company.businessUnits ?? []).filter((unit) => unit.kind === 'ESTABLISHMENT')}
        />
      </section>
    </GatedCompanyScreen>
  );
}
